import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './toggleSwitch.scss';

function ToggleSwitch({ id, value, onChange, disabled }) {
  const toggleSwitch = (event) => {
    const { checked } = event.target;
    if (isFunction(onChange)) {
      onChange(checked);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isFunction(onChange)) {
        onChange(!value);
      }
    }
  };

  return (
    <label
      htmlFor={`toggle-switch-${id}`}
      className={styles['toggle-switch']}
    >
      <input
        type="checkbox"
        id={`toggle-switch-${id}`}
        checked={value}
        disabled={disabled}
        onChange={toggleSwitch}
        onKeyDown={handleKeyDown}
        aria-checked={value}
        role="switch"
      />
      <span className={styles.switch} />
    </label>
  );
}

ToggleSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

ToggleSwitch.defaultProps = {
  disabled: false
};

export default ToggleSwitch;